import axios from "axios";
import router from "@/router";
import store from "../store";
import { Toast  } from 'vant';
const axiosIns = axios.create({});

if (window.API_URL.length > 0) {
  //强制指定接口地址
  axiosIns.defaults.baseURL = window.API_URL;
} else {
  //内部系统按环境区分
  if (process.env.NODE_ENV == "development") {
    axiosIns.defaults.baseURL = "/gateway";
  } else if (process.env.NODE_ENV === "testing") {
    axiosIns.defaults.baseURL = "/gateway";
  } else if (process.env.NODE_ENV == "production") {
    axiosIns.defaults.baseURL = "/gateway";
  }
}
const token = localStorage.getItem("token");
axiosIns.interceptors.request.use(
  function(config) {
    if (store.state.token || token) {
      console.log()
      config.headers["token"] = store.state.token || token;
    }

    return config;
  }
);

axiosIns.interceptors.response.use(function(response) {
  let data = response.data;
  console.log("data", data);
  if (data.success === true) {
    return Promise.resolve(data);
  } else {
    Toast.fail(data.message)
    return Promise.reject(data.message);
  }
});

export default axiosIns;



// WEBPACK FOOTER //
// ./src/utils/axios.js